export default __webpack_public_path__ + "static/media/star.c47a2f84.svg";